/**
 * Local-calendar-day ↔ 'YYYY-MM-DD' helpers for the stats date pickers.
 * The canonical implementation now lives in `@mfw/common/utils/date.ts`
 * (`toCivilDate`) — this file only re-exports it under the historical name
 * and keeps the picker-specific helpers.
 */
import { toCivilDate } from '@mfw/common';

/** Local calendar day of `date` as 'YYYY-MM-DD'. */
export { toCivilDate as toIsoDay } from '@mfw/common';

/** Today's LOCAL day as 'YYYY-MM-DD' — matches BE businessToday for users
 * whose timezone = device timezone. */
export function todayIso(): string {
  return toCivilDate(new Date());
}

/** 'YYYY-MM-DD' → Date at LOCAL midnight (what the MUI picker expects). */
export { fromCivilDate as fromIsoDay } from '@mfw/common';

/** DatePicker fires onChange while typing — commit only complete, plausible dates. */
export function isPlausiblePickerDate(date: unknown): date is Date {
  return (
    date instanceof Date &&
    !Number.isNaN(date.getTime()) &&
    date.getFullYear() >= 1970 &&
    date.getFullYear() <= 2100
  );
}
